"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VerifyCodeFromMailForm = void 0;
var _react = _interopRequireDefault(require("react"));
var _CodeFromMailForm = require("./CodeFromMailForm");
var _EmailForm = require("./EmailForm");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var VerifyCodeFromMailForm = function VerifyCodeFromMailForm(_ref) {
  var email = _ref.email,
    send = _ref.send,
    sendTimeout = _ref.sendTimeout,
    sendLoading = _ref.sendLoading,
    verify = _ref.verify,
    verifyLoading = _ref.verifyLoading,
    hideTerms = _ref.hideTerms;
  return email ? /*#__PURE__*/_react.default.createElement(_CodeFromMailForm.CodeFromMailForm, {
    onSubmit: function onSubmit(_ref2) {
      var code = _ref2.code;
      return verify({
        code: code
      });
    },
    send: send,
    sendLoading: sendLoading,
    sendTimeout: sendTimeout,
    verifyLoading: verifyLoading
  }) : /*#__PURE__*/_react.default.createElement(_EmailForm.EmailForm, {
    sendCodeLoading: sendLoading,
    hideTerms: hideTerms,
    onSubmit: function onSubmit(_ref3) {
      var email = _ref3.email;
      return send(email);
    }
  });
};
exports.VerifyCodeFromMailForm = VerifyCodeFromMailForm;